<template>
    <div class="content">
        <img src="../../assets/img/sstz_bg2.png" alt="">
        <div class="download" v-show="isWeixin" @click="doJump">
            <img src="../../assets/img/download_but2.png" alt="">
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                isWeixin: true
            }
        },
        created () {
            document.title = "海科商户通上线啦";
            this.is_weixn();
        },
        methods: {
            // 判断是不是微信浏览器
            is_weixn() {
                var ua = navigator.userAgent.toLowerCase();
                if (ua.match(/MicroMessenger/i) == "micromessenger") {
                    this.isWeixin = true;
                } else {
                    this.isWeixin = false;
                }
            },
            doJump(){
                this.$router.push({
                    name:'appDownload'
                })
            }
        },
    }
</script>

<style scoped>
.content img{
    width: 100%;
    display: block;
    margin: 0 auto;
}
.download{
    background: #e42325;
    padding: 20px 0 50px;
}
.download img{
    width: 330px;
    display: block;
    margin: 0 auto;
}
</style>